import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    Button,
    Input,
    PageTitle,
    Loading,
    Tabs,
    Tooltip
} from '../root/components/common'
import { Typography } from '@material-ui/core'

import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from '../network-devices/actions'

import ArrowBackIcon from '@material-ui/icons/ArrowBackIos'

import { IconButton } from '@material-ui/core'
import { UserPermissions } from '../../services/permissions'
import { NetworkDeviceStatus } from '../root/components/common/network-device-status'
import moment from 'moment'
import CustomButton from '../root/components/common/button'
import InfoCircle from '../../assets/svg/info-circle.svg'
import SimCardIccid from '../../assets/img/sim-card-iccid.png'
import { CustomInputWithButton } from '../root/components/common/input-with-button'
import { validateIccid } from 'web/src/utils'
import { List, AutoSizer } from 'react-virtualized'
import { NavLink } from 'react-router-dom'
import { useSimCardsApi } from '../root/hooks/use-sim-cards-api'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    sectionsWrapper: {
        display: 'flex',
        flexDirection: 'row'
    },
    detailsWrapper: {
        flex: 1
    },
    input: {
        marginBottom: 16
    },
    detailsRow: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center'
    },
    detailsNameColumn: {
        flex: 1,
        color: theme.quaternary,
        fontWeight: 'bold'
    },
    detailsValueColumn: {
        flex: 1,
        display: 'flex',
        alignItems: 'center'
    },
    detailsInfoWrapper: {
        paddingLeft: 20
    },
    backButton: {
        marginRight: 16
    },
    arrowBackIcon: {
        color: theme.primary
    },
    actionButton: {
        marginRight: 8
    },
    select: {
        marginBottom: 16
    },
    tabs: {
        marginBottom: 16
    },
    section: {
        marginTop: 16
    },
    pageTitle: {
        display: 'flex'
    },
    statusCard: {
        marginTop: 16
    },
    statusCardContent: {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        flexWrap: 'wrap',
        maxHeight: 250,
        overflow: 'auto'
    },
    addSimCardWrapper: {
        display: 'flex',
        gap: 10
    },
    addSimCardTooltip: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 5
    },
    link: {
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.primary,
        fontWeight: 'bold'
    }
}))

function NetworkDevice(props) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const networkDeviceId = props.match.params.networkDeviceId
    const returnUrl = new URLSearchParams(props.location.search).get('return')
    const { isLoading, theme, locale } = useSelector(state => state.main)
    const { networkDevice } = useSelector(state => state.networkDevices)

    const [isShowNewSimCardForm, setIsShowNewSimCardForm] = useState(false)
    const [simCardSerialNumber, setSimCardSerialNumber] = useState('')
    const [simCardError, setSimCardError] = useState('')
    const [description, setDescription] = useState(
        networkDevice ? networkDevice.description : ''
    )

    const { createSimCard, isCreatingSimCard } = useSimCardsApi({
        locale: locale,
        networkDeviceId: networkDeviceId
    })

    const permissions = {
        updateDevice:
            UserPermissions.device(networkDevice && networkDevice.customer_id)
                .update ||
            (networkDevice?.is_original &&
                UserPermissions.isAllOriginalGranted())
    }

    const save = () => {
        const data = {
            //        name,
            description
        }
        // if (!isValid(data)) {
        //     return
        // }
        dispatch(actions.updateNetworkDeviceRequest(networkDeviceId, data))
    }

    const goBackToLocationDevices = () => {
        props.history.push(returnUrl)
    }

    useEffect(() => {
        dispatch(actions.networkDeviceRequest(networkDeviceId))
    }, [networkDeviceId])

    useEffect(() => {
        setDescription(networkDevice ? networkDevice.description : '')
    }, [networkDevice])

    const TABS = {
        overview: {
            key: 'overview',
            name: locale.locations.overview
        }
    }

    const handleAddCardClick = () => setIsShowNewSimCardForm(true)

    const handleSaveSimCard = () => {
        if (!simCardSerialNumber) {
            setSimCardError(locale.simCards.simCardEmptyError)
            return
        }

        if (!validateIccid(simCardSerialNumber)) {
            setSimCardError(locale.simCards.simCardNotValidIccidError)
            return
        }

        setSimCardError('')
        createSimCard({
            simSerialNumber: simCardSerialNumber,
            device_id: networkDeviceId
        })
    }

    const handleCancelSimCard = () => {
        setIsShowNewSimCardForm(false)
        setSimCardSerialNumber('')
        setSimCardError('')
    }

    const RenderStatusHistory = () => {
        const statusHistory = networkDevice?.data?.tti?.history
        if (!statusHistory || statusHistory.length === 0) {
            return null
        }

        statusHistory.sort((a, b) => new Date(b.date) - new Date(a.date))

        const rowHeight = 60

        const rowRenderer = ({ index, key, style }) => {
            const status = statusHistory[index]
            return (
                <div
                    key={key}
                    style={{
                        ...style,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px',
                        borderBottom: '1px solid #eee'
                    }}>
                    <NetworkDeviceStatus value={status.status} />
                    <Typography style={{ marginLeft: 100 }}>
                        {moment(status.date).format('MMM D, YYYY - HH:mm')}
                    </Typography>
                </div>
            )
        }

        return (
            <div style={{ marginTop: 60, width: '100%', height: '330px' }}>
                <Typography
                    style={{
                        color: theme.primary,
                        textDecorationLine: 'underline',
                        marginBottom: 10
                    }}>
                    {locale.devices.history}:
                </Typography>
                <div
                    style={{
                        backgroundColor: theme.background,
                        border: theme.border,
                        borderRadius: theme.borderRadius,
                        height: 300
                    }}>
                    <AutoSizer>
                        {({ width, height }) => (
                            <List
                                width={width}
                                height={height}
                                rowCount={statusHistory.length}
                                rowHeight={rowHeight}
                                rowRenderer={rowRenderer}
                            />
                        )}
                    </AutoSizer>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Tabs
                className={classes.tabs}
                tabs={TABS}
                currentTab={'overview'}
                setCurrentTab={null}
                centered={false}
            />
            <div className={classes.wrapper}>
                {networkDevice && (
                    <React.Fragment>
                        <>
                            {isLoading || isCreatingSimCard ? (
                                <Loading />
                            ) : (
                                <>
                                    <PageTitle
                                        beforeContent={
                                            returnUrl ? (
                                                <IconButton
                                                    className={
                                                        classes.backButton
                                                    }
                                                    onClick={
                                                        goBackToLocationDevices
                                                    }>
                                                    <ArrowBackIcon
                                                        className={
                                                            classes.arrowBackIcon
                                                        }
                                                    />
                                                </IconButton>
                                            ) : null
                                        }
                                        title={
                                            <div className={classes.pageTitle}>
                                                {networkDevice.serial_number}
                                            </div>
                                        }></PageTitle>
                                    <div className={classes.sectionsWrapper}>
                                        <div className={classes.detailsWrapper}>
                                            <Input
                                                className={classes.input}
                                                label={
                                                    locale.common.description
                                                }
                                                type="text"
                                                setValue={setDescription}
                                                value={description}
                                                onEnter={save}
                                                disabled={
                                                    !permissions.updateDevice
                                                }
                                            />

                                            {permissions.updateDevice && (
                                                <Button onClick={save}>
                                                    {locale.common.save}
                                                </Button>
                                            )}
                                            <RenderStatusHistory />
                                        </div>
                                        <div className={classes.detailsWrapper}>
                                            <div
                                                className={
                                                    classes.detailsInfoWrapper
                                                }>
                                                <div
                                                    className={
                                                        classes.detailsRow
                                                    }>
                                                    <div
                                                        className={
                                                            classes.detailsNameColumn
                                                        }>
                                                        {
                                                            locale.devices
                                                                .organisation
                                                        }
                                                        :
                                                    </div>
                                                    <div
                                                        className={
                                                            classes.detailsValueColumn
                                                        }>
                                                        {
                                                            networkDevice.customer_name
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        classes.detailsRow
                                                    }>
                                                    <div
                                                        className={
                                                            classes.detailsNameColumn
                                                        }>
                                                        {
                                                            locale.devices
                                                                .location
                                                        }
                                                        :
                                                    </div>
                                                    <div
                                                        className={
                                                            classes.detailsValueColumn
                                                        }>
                                                        <NavLink
                                                            className={
                                                                classes.link
                                                            }
                                                            to={`/locations/${networkDevice.location_id}/overview`}>
                                                            {
                                                                networkDevice.location_name
                                                            }
                                                        </NavLink>
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        classes.detailsRow
                                                    }>
                                                    <div
                                                        className={
                                                            classes.detailsNameColumn
                                                        }>
                                                        {
                                                            locale.devices
                                                                .deviceType
                                                        }
                                                        :
                                                    </div>
                                                    <div
                                                        className={
                                                            classes.detailsValueColumn
                                                        }>
                                                        {'Router'}
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        classes.detailsRow
                                                    }>
                                                    <div
                                                        className={
                                                            classes.detailsNameColumn
                                                        }>
                                                        {
                                                            locale.devices
                                                                .routerType
                                                        }
                                                        :
                                                    </div>
                                                    <div
                                                        className={
                                                            classes.detailsValueColumn
                                                        }>
                                                        {
                                                            networkDevice.router_type
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        classes.detailsRow
                                                    }>
                                                    <div
                                                        className={
                                                            classes.detailsNameColumn
                                                        }>
                                                        {
                                                            locale.devices
                                                                .serialNr
                                                        }
                                                        :
                                                    </div>
                                                    <div
                                                        className={
                                                            classes.detailsValueColumn
                                                        }>
                                                        {
                                                            networkDevice.serial_number
                                                        }
                                                    </div>
                                                </div>
                                                {networkDevice.hasSimCard && (
                                                    <div
                                                        className={
                                                            classes.detailsRow
                                                        }>
                                                        <div
                                                            className={
                                                                classes.detailsNameColumn
                                                            }>
                                                            {
                                                                locale.simCards
                                                                    .simCard
                                                            }
                                                            :
                                                        </div>
                                                        <div
                                                            className={
                                                                classes.detailsValueColumn
                                                            }>
                                                            {networkDevice.sim_serial_number ? (
                                                                networkDevice.sim_serial_number
                                                            ) : (
                                                                <div
                                                                    className={
                                                                        classes.addSimCardWrapper
                                                                    }>
                                                                    {isShowNewSimCardForm ? (
                                                                        <CustomInputWithButton
                                                                            label={
                                                                                locale
                                                                                    .simCards
                                                                                    .simCardSerialNumber
                                                                            }
                                                                            value={
                                                                                simCardSerialNumber
                                                                            }
                                                                            onChange={
                                                                                setSimCardSerialNumber
                                                                            }
                                                                            btnLabel={
                                                                                locale
                                                                                    .common
                                                                                    .save
                                                                            }
                                                                            handleCancelClick={
                                                                                handleCancelSimCard
                                                                            }
                                                                            handleBtnClick={
                                                                                handleSaveSimCard
                                                                            }
                                                                            errorText={
                                                                                simCardError
                                                                            }
                                                                            isError={
                                                                                !!simCardError
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <>
                                                                            <CustomButton
                                                                                onClick={
                                                                                    handleAddCardClick
                                                                                }>
                                                                                {
                                                                                    locale
                                                                                        .simCards
                                                                                        .addSimCardLabel
                                                                                }
                                                                            </CustomButton>
                                                                            <Tooltip
                                                                                hover
                                                                                text={
                                                                                    <div
                                                                                        className={
                                                                                            classes.addSimCardTooltip
                                                                                        }>
                                                                                        <span>
                                                                                            {
                                                                                                locale
                                                                                                    .simCards
                                                                                                    .addSimCardTooltipText
                                                                                            }
                                                                                        </span>
                                                                                        <img
                                                                                            width={
                                                                                                140
                                                                                            }
                                                                                            src={
                                                                                                SimCardIccid
                                                                                            }
                                                                                            alt="icon"
                                                                                        />
                                                                                    </div>
                                                                                }>
                                                                                <img
                                                                                    src={
                                                                                        InfoCircle
                                                                                    }
                                                                                    alt="icon"
                                                                                />
                                                                            </Tooltip>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {networkDevice.hasSimCard && (
                                                    <div
                                                        className={
                                                            classes.detailsRow
                                                        }>
                                                        <div
                                                            className={
                                                                classes.detailsNameColumn
                                                            }>
                                                            {
                                                                locale.devices
                                                                    .status
                                                            }
                                                            :
                                                        </div>
                                                        <div
                                                            className={
                                                                classes.detailsValueColumn
                                                            }>
                                                            <NetworkDeviceStatus
                                                                value={
                                                                    networkDevice
                                                                        .data
                                                                        ?.tti
                                                                        ?.status
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                    </React.Fragment>
                )}
                {!isLoading && !networkDevice && (
                    <div>{locale.devices.deviceIsNotFound}</div>
                )}
            </div>
        </div>
    )
}

export default withRouter(NetworkDevice)
